import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Input, Space, Select } from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SlackOutlined,
} from '@ant-design/icons'
import { toast } from 'react-toastify'
import axiosInstance from '../../Utils/axiosInstance'
import { CreateRawMaterialDataAPI, GetRawMaterialDataAPI, UpdateRawMaterialDataAPI } from '../../AllAPI/AdminAPI'

const RawMaterialMaster = () => {
  const selectedYear = Number(sessionStorage.getItem('year'))
  const [materials, setMaterials] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  /* ================= Modal + Inputs ================= */
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingId, setEditingId] = useState(null)

  const [materialName, setMaterialName] = useState('')
  const [unit, setUnit] = useState('')

   useEffect(() => {
    fetchMaterials()
  }, [])

  const fetchMaterials = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get(`${GetRawMaterialDataAPI}/${selectedYear}`)
      setMaterials(Array.isArray(res.data) ? res.data : [])
    } catch {
      toast.error('Failed to load raw material')
    } finally {
      setLoading(false)
    }
  }

  /* ================= Delete ================= */
  // const [deleteId, setDeleteId] = useState(null)

  /* ================= Open Modal ================= */
  const openModal = (record = null) => {
    if (record) {
      setEditingId(record.id)
      setMaterialName(record.material_name)
      setUnit(record.unit)
    } else {
      setEditingId(null)
      setMaterialName('')
      setUnit('')
    }
    setIsModalOpen(true)
  }

  const resetForm = () => {
  setEditingId(null)
  setMaterialName('')
  setUnit('')
}


  /* ================= Save / Update ================= */
const handleSave = async () => {
  if (!materialName.trim()) {
    return toast.error('Material name is required')
  }

  if (!unit) {
    return toast.error('Unit is required')
  }

  try {
    setLoading(true)

    const objData ={
      material_name : materialName,
      unit : unit,
      year : selectedYear,
    }

    if (editingId) {
      // 🔁 UPDATE
      const res = await axiosInstance.put( `${UpdateRawMaterialDataAPI}/${editingId}`, objData )
       if (res.data === "UPDATED") {          
                toast.success('Raw material updated successfully')
              }
              else if(res.data === "ERROR"){
                toast.warn('Error Occurred! Try Again')
              }
    } else {
      const res = await axiosInstance.post( CreateRawMaterialDataAPI, objData )
       if (res.data === "SAVED") {          
                toast.success('Raw material added successfully')
              } else if(res.data === "ERROR"){
                toast.warn('Error Occurred! Try Again')
              }
    }

    fetchMaterials()
    setIsModalOpen(false)
    resetForm()
  } catch (error) {
    console.error(error)
    toast.error('Something went wrong')
  } finally {
    setLoading(false)
  }
}

  /* ================= Delete ================= */
  // const confirmDelete = () => {
  //   setMaterials((prev) => prev.filter((m) => m.id !== deleteId))
  //   toast.success('Raw material deleted')
  //   setDeleteId(null)
  // }

  /* ================= Search ================= */
  const filteredMaterials = materials.filter((m) =>
    m.material_name?.toLowerCase().includes(searchText.toLowerCase()),
  )

  /* ================= Table ================= */
  const columns = [
    {
      title: 'Material Name',
      dataIndex: 'material_name',
    },
    {
      title: 'Unit',
      dataIndex: 'unit',
    },
    {
      title: 'Actions',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => openModal(record)}
          />
          {/* <Button
            icon={<DeleteOutlined />}
            size="small"
            danger
            onClick={() => setDeleteId(record.id)}
          /> */}
        </Space>
      ),
    },
  ]

  return (
    <>
      <div className="mainContainer">
        <div className="header-row">
          <h3>
            <SlackOutlined style={{ color: 'orangered' }} /> Raw Material Master
          </h3>
        </div>

        <div className="search-bar text-end">
          <Button
            className="addButton mx-md-2"
            icon={<PlusOutlined />}
            onClick={() => openModal()}
          >
            Add
          </Button>

          <Input
            placeholder="Search material..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 250 }}
          />
        </div>

        <Table
          columns={columns}
          dataSource={filteredMaterials}
          rowKey="id"
          loading={loading}
          bordered
          className='shadow'
          style={{overflowX:"auto"}}
        />
      </div>

      {/* ================= MODAL ================= */}
      <Modal
        title={editingId ? 'Edit Raw Material' : 'Add Raw Material'}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            {editingId ? 'Update' : 'Save'}
          </Button>,
        ]}
      >
        <label>Material Name</label>
        <Input
          value={materialName}
          onChange={(e) => setMaterialName(e.target.value)}
          placeholder="Enter material name"
        />

        <label className="mt-2">Unit</label>
        <Select
          value={unit}
          onChange={setUnit}
          placeholder="Select unit"
          style={{ width: '100%' }}
        >
          <Select.Option value="Kg">Kg</Select.Option>
          <Select.Option value="Litre">Litre</Select.Option>
          <Select.Option value="Nos">Nos</Select.Option>
        </Select>
      </Modal>

      {/* ================= DELETE ================= */}
      {/* <Modal
        title="Confirm Delete"
        open={!!deleteId}
        onCancel={() => setDeleteId(null)}
        onOk={confirmDelete}
        okText="Delete"
        okButtonProps={{ danger: true }}
      >
        Are you sure you want to delete this raw material?
      </Modal> */}
    </>
  )
}

export default RawMaterialMaster
